import { createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-b785f1d4")

_pushScopeId("data-v-b785f1d4")
const _hoisted_1 = { class: "template-commands" }
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "command-usage" }, [
  /*#__PURE__*/_createVNode("p", { class: "bold" }, [
    /*#__PURE__*/_createTextVNode(" 下の画像をドラッグするとコマの順番"),
    /*#__PURE__*/_createVNode("br"),
    /*#__PURE__*/_createTextVNode(" 変更ができます。"),
    /*#__PURE__*/_createVNode("br"),
    /*#__PURE__*/_createTextVNode(" 順番変更を行うとそれまでの作業履歴"),
    /*#__PURE__*/_createVNode("br"),
    /*#__PURE__*/_createTextVNode(" がクリアされ、入れ替え前の状態に戻"),
    /*#__PURE__*/_createVNode("br"),
    /*#__PURE__*/_createTextVNode(" れなくなります。必要に応じて入れ替え"),
    /*#__PURE__*/_createVNode("br"),
    /*#__PURE__*/_createTextVNode(" 前に保存してください。"),
    /*#__PURE__*/_createVNode("br")
  ])
], -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("hr", { class: "h-line" }, null, -1)
const _hoisted_4 = { class: "display" }
const _hoisted_5 = /*#__PURE__*/_createVNode("span", null, "保存", -1)
const _hoisted_6 = { class: "frame-list" }
const _hoisted_7 = /*#__PURE__*/_createVNode("span", null, "他のマンガのコマと入替", -1)
const _hoisted_8 = /*#__PURE__*/_createVNode("span", null, "ダウンロード", -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_fa = _resolveComponent("fa")
  const _component_EditTitle = _resolveComponent("EditTitle")
  const _component_EditSelectFrame = _resolveComponent("EditSelectFrame")
  const _component_draggable = _resolveComponent("draggable")
  const _component_EditDownload = _resolveComponent("EditDownload")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _createVNode("div", _hoisted_4, [
      _createVNode("button", {
        class: "primary-button margin undo-redo",
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.undo.undo && _ctx.undo.undo(...args))),
        disabled: _ctx.undo.disUndo()
      }, [
        _createVNode(_component_fa, { icon: ['fas', 'undo'] })
      ], 8, ["disabled"]),
      _createVNode("button", {
        class: "primary-button margin undo-redo",
        onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.undo.redo && _ctx.undo.redo(...args))),
        disabled: _ctx.undo.disRedo()
      }, [
        _createVNode(_component_fa, { icon: ['fas', 'redo'] })
      ], 8, ["disabled"]),
      _createVNode("button", {
        class: "primary-button margin save",
        onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.showSave && _ctx.showSave(...args)))
      }, [
        _createVNode(_component_fa, { icon: ['fas', 'save'] }),
        _hoisted_5
      ])
    ]),
    _createVNode(_component_EditTitle, {
      isShowModal: _ctx.isShowSave,
      "onUpdate:isShowModal": _cache[4] || (_cache[4] = ($event: any) => (_ctx.isShowSave = $event)),
      isSaveAs: true,
      editStore: _ctx.editStore,
      onDone: _cache[5] || (_cache[5] = ($event: any) => (_ctx.context.emit('save', $event, _ctx.images)))
    }, null, 8, ["isShowModal", "editStore"]),
    _createVNode(_component_EditSelectFrame, {
      isShowModal: _ctx.isShowSelectFrame,
      "onUpdate:isShowModal": _cache[6] || (_cache[6] = ($event: any) => (_ctx.isShowSelectFrame = $event)),
      templates: _ctx.templates,
      onDone: _ctx.selectFrame
    }, null, 8, ["isShowModal", "templates", "onDone"]),
    _createVNode("div", _hoisted_6, [
      _createVNode(_component_draggable, {
        modelValue: _ctx.frameList,
        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.frameList = $event)),
        animation: 300
      }, {
        default: _withId(() => [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.frameList, (fe) => {
            return (_openBlock(), _createBlock("button", {
              key: fe.index,
              onClick: ($event: any) => (_ctx.editStore?.selectFrame(fe.index)),
              onMousedown: ($event: any) => (_ctx.touchedFrame(fe.index))
            }, [
              _createVNode("img", {
                src: _ctx.frameToResourceUrl(fe.frame, fe.edit.isBalloonOn)
              }, null, 8, ["src"])
            ], 40, ["onClick", "onMousedown"]))
          }), 128))
        ]),
        _: 1
      }, 8, ["modelValue"])
    ]),
    _createVNode("button", {
      class: "primary-button",
      onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.showSelectFrame && _ctx.showSelectFrame(...args)))
    }, [
      _hoisted_7
    ]),
    _createVNode("button", {
      class: "primary-button download",
      onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.showDownload && _ctx.showDownload(...args)))
    }, [
      _createVNode(_component_fa, { icon: ['fas', 'cloud-download-alt'] }),
      _hoisted_8
    ]),
    _createVNode(_component_EditDownload, {
      editStore: _ctx.editStore,
      images: _ctx.images,
      isShowModal: _ctx.isShowDownload,
      "onUpdate:isShowModal": _cache[10] || (_cache[10] = ($event: any) => (_ctx.isShowDownload = $event))
    }, null, 8, ["editStore", "images", "isShowModal"])
  ]))
})